import { render, staticRenderFns } from "./VetClaimManage.vue?vue&type=template&id=9baeb87e&"
import script from "./VetClaimManage.vue?vue&type=script&lang=js&"
export * from "./VetClaimManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports